import { useDocumentTabDataContext } from 'features/knowledgeDocumentViewer/contexts/DocumentTabDataContext'
import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { usePipelineConfig } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { useSystemDocumentPageByNum } from 'features/knowledgeDocumentViewer/hooks/useSystemDocumentPageByNum'
import { useGeckoPermissions } from 'features/permissions'
import { PERMISSION_CANTILEVER_LOTO_VIEWER } from 'types'

import { scopedPageAttachment } from './lotoPageAddition'
import {
  type LotoAttachment,
  type LotoReportScope,
  lotoReportScopeSchema,
} from './lotoReportSchemas'

export type LotoPage = {
  scope: LotoReportScope
  attachment: LotoAttachment
  documentName: string
  pageNumber: number
}

export function useLotoScope(): LotoReportScope | undefined {
  const { orgID, siteID } = useKnowledgeDocumentDataContext()
  const { isLabelerMode } = useKnowledgeDocumentUXContext()
  const { selectedPipelineConfigId } = usePipelineConfig()
  const { hasPermissions } = useGeckoPermissions()
  const scope = lotoReportScopeSchema.safeParse({
    organization: orgID,
    site: siteID,
    pipelineConfig: selectedPipelineConfigId,
  }).data
  return !isLabelerMode && hasPermissions([PERMISSION_CANTILEVER_LOTO_VIEWER])
    ? scope
    : undefined
}

export function useLotoPage(
  scope: LotoReportScope | undefined
): LotoPage | undefined {
  const {
    systemDocumentEntryId,
    bqDocumentId,
    pageNumber,
    documentTableRow,
    documentFilename,
  } = useDocumentTabDataContext()
  const { page } = useSystemDocumentPageByNum({
    systemDocumentEntryId,
    bqDocumentId,
    pageNum: pageNumber,
    enabled: scope !== undefined,
  })
  const attachment =
    scope && page
      ? scopedPageAttachment(page.entry.id, page.entry.tags, scope)
      : undefined
  if (!scope || !attachment) return undefined
  return {
    scope,
    attachment,
    documentName:
      documentTableRow?.drawing ||
      documentTableRow?.title ||
      documentFilename ||
      '',
    pageNumber,
  }
}
